import React from 'react';
import { SmileIcon, SendIcon } from 'lucide-react';
export const CommentThread = () => {
  const comments = [{
    id: 1,
    author: 'Emma Thompson',
    avatar: 'ET',
    avatarColor: 'bg-green-500',
    content: 'I noticed a significant increase in customer satisfaction after we implemented the new feedback collection system. This is great progress!',
    time: '2 hours ago',
    reactions: [{
      emoji: '👍',
      count: 4
    }, {
      emoji: '🎉',
      count: 2
    }]
  }, {
    id: 2,
    author: 'Michael Chen',
    avatar: 'MC',
    avatarColor: 'bg-purple-500',
    content: "The research team has completed the analysis of the onboarding friction points. I'll create a detailed report and share it with everyone by tomorrow.",
    time: '1 hour ago',
    reactions: [{
      emoji: '👍',
      count: 2
    }]
  }, {
    id: 3,
    author: 'Sarah Johnson',
    avatar: 'SJ',
    avatarColor: 'bg-yellow-500',
    content: "I've scheduled a meeting with the product team to discuss how we can implement these insights into our roadmap. Let me know if anyone else wants to join.",
    time: '30 minutes ago',
    reactions: []
  }];
  return <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-61">
      <div className="space-y-4 mb-4" data-id="element-62">
        {comments.map(comment => <div key={comment.id} className="flex gap-3" data-id="element-63">
            <div className={`w-8 h-8 rounded-full ${comment.avatarColor} flex items-center justify-center text-white font-medium text-xs flex-shrink-0`} data-id="element-64">
              {comment.avatar}
            </div>
            <div className="flex-1" data-id="element-65">
              <div className="flex items-center gap-2 mb-1" data-id="element-66">
                <span className="font-medium text-gray-800" data-id="element-67">
                  {comment.author}
                </span>
                <span className="text-xs text-gray-500" data-id="element-68">{comment.time}</span>
              </div>
              <p className="text-sm text-gray-700 mb-2" data-id="element-69">{comment.content}</p>
              <div className="flex items-center gap-2" data-id="element-70">
                {comment.reactions.map((reaction, index) => <div key={index} className="flex items-center gap-1 bg-gray-100 rounded-full px-2 py-0.5 text-xs" data-id="element-71">
                    <span data-id="element-72">{reaction.emoji}</span>
                    <span className="text-gray-600" data-id="element-73">{reaction.count}</span>
                  </div>)}
                <button className="text-gray-400 hover:text-gray-600 text-xs" data-id="element-74">
                  Reply
                </button>
                <button className="text-gray-400 hover:text-gray-600 text-xs flex items-center gap-1" data-id="element-75">
                  <SmileIcon size={14} data-id="element-76" />
                  React
                </button>
              </div>
            </div>
          </div>)}
      </div>
      <div className="flex gap-3 pt-3 border-t border-gray-200" data-id="element-77">
        <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-medium text-xs flex-shrink-0" data-id="element-78">
          JD
        </div>
        <div className="flex-1 relative" data-id="element-79">
          <input type="text" placeholder="Add your comment..." className="w-full border border-gray-300 rounded-md px-3 py-2 pr-10 text-sm focus:outline-none focus:border-blue-500" data-id="element-80" />
          <button className="absolute right-3 top-1/2 -translate-y-1/2 text-blue-500" data-id="element-81">
            <SendIcon size={16} data-id="element-82" />
          </button>
        </div>
      </div>
    </div>;
};